export const SALES_INVOICES_QUERY_KEY = 'sales_invoices';
export const PURCHASE_INVOICES_QUERY_KEY = 'purchase_invoices';
export const BANK_STATEMENT_QUERY_KEY = 'bank_statement';
export const PAYMENTS_QUERY_KEY = 'payments';
export const REPORTS_QUERY_KEY = 'reports';
export const BANK_ACCOUNTS_QUERY_KEY = 'bank_accounts';
export const CONTACTS_QUERY_KEY = 'contacts';
export const NOTIFICATIONS_QUERY_KEY = 'notifications';
export const INBOX_NOTIFICATIONS_QUERY_KEY = 'inbox_notifications';
export const COMMUNICATIONS_QUERY_KEY = 'communications';
export const USERS_QUERY_KEY = 'users';
export const USERS_ME_QUERY_KEY = 'me';
export const PAYMENT_METHODS_QUERY_KEY = 'payment_methods';
export const REFERRAL_DATA_QUERY_KEY = 'referral_data';
export const REFERRAL_HISTORY_QUERY_KEY = 'referral_history';
export const SETUP_INTENT_CARD_VERIFICATION_KEY = 'setup_intent_secret';
export const ANNUAL_REPORT_QUERY_KEY = 'annual_report';
export const MATCHING_QUERY_KEY = 'matching';
export const CONTRACTORS_QUERY_KEY = 'contractors';
export const CONTRACTORS_INVOICES_QUERY_KEY = 'contractors_invoices';
export const CONTRACTOR_ID_QUERY_KEY = 'contractor_id';
export const TRAVELS_QUERY_KEY = 'business_travels';
export const SECURE_DOWNLOAD_DOCS_QUERY_KEY = 'secure_download_docs';
export const EMPLOYEES_QUERY_KEY = 'employees';
export const OLD_EMPLOYEES_QUERY_KEY = 'old_company_employees';
export const EMPLOYEE_ID_QUERY_KEY = 'employee_id';
export const OLD_EMPLOYEE_ID_QUERY_KEY = 'old_company_employee_id';
export const OLD_EMPLOYEE_SALARIES_QUERY_KEY = 'old_company_employee_salaries';
export const EOR_SERVICE_CONTRACT_QUERY_KEY = 'eor_service_contract';
export const MONTH_PAYROLL_QUERY_KEY = 'month_payroll';
export const MATCHING_TRANSACTION_ID_QUERY_KEY = 'matching_transaction_id';
export const TRANSACTIONS_QUERY_KEY = 'transactions';
export const BALANCES_QUERY_KEY = 'balances';
export const MATCHING_ENTITY_DOCUMENT_QUERY_KEY = 'matching_entity_document';
export const TICKETS_QUERY_KEY = 'tickets';
export const LOAN_AGREEMENTS_QUERY_KEY = 'loan_agreements';
export const CERTIFICATE_QUERY_KEY = 'certificate';
export const COMPANY_QUERY_KEY = 'companies';
export const COMPANY_REGISTRATION_QUERY_KEY = 'company_registration';
export const PROJECTS_QUERY_KEY = 'projects';
export const PROJECT_DOCUMENTS_QUERY_KEY = 'project_documents';
export const DOCUMENTS_QUERY_KEY = 'documents';
export const MATCHING_ID_POPULATED_QUERY_KEY = 'matching_id_populated';
export const BANK_MIGRATIONS_KEY = 'bank_migrations';
export const BANK_TYPES_KEY = 'bank_types';
export const STATEMENTS_QUERY_KEY = 'statements';
export const TAGS_QUERY_KEY = 'tags';
export const REPORT_ID_QUERY_KEY = 'report_id';
export const COMPANION_QUERY_KEY = 'companion';
export const ANNUAL_REPORT_GET_MATCHING_BY_ENTITY_ID = 'annual_report_get_matching_by_entity_id';
export const CONTRACTORS_ALL_QUERY_KEY = 'contractors_all';
export const CONTRACTOR_CHECK_ASSOCIATION_BETWEEN_INVOICE_AND_CONTRACTOR_QUERY_KEY =
  'contractor_check_association_between_invoice_and_contractor';
export const TRAVELS_OF_BOARD_MEMBER_WITH_ID_QUERY_KEY = 'travels_of_board_member_with_id';
export const WORKFLOWS_QUERY_KEY = 'workflows';
export const METRIC_QUERY_KEY = 'metric';
export const LOAN_AGREEMENTS_BY_TYPE_KEY = 'loan_agreements_by_type';
export const OTHER_DOCUMENTS_QUERY_KEY = 'other_documents';
export const COMPANY_INVOICE_AVATAR_QUERY_KEY = 'company_invoice_avatar';
export const TICKETS_PAGINATED_BY_DATE_QUERY_KEY = 'tickets_paginated_by_date';
export const PASSPORTS_QUERY_KEY = 'passports';
export const MEMBERS_QUERY_KEY = 'members';
export const PAYMENT_CLIENT_SECRET_QUERY_KEY = 'payment_client_secret';
export const MULTI_DOCUMENTS_QUERY_KEY = 'multi_documents';
export const EU_VAT_RATES_QUERY_KEY = 'vat_rate';
export const VAT_QUERY_KEY = 'vat';
export const UNSUPPORTED_COUNTRIES_KEY = 'unsupported_countries';
export const MARKETPLACE_QUERY_KEY = 'marketplace_entries';
export const MISSING_BANKS_KEY = 'missing_banks';
